import { type Breakpoint } from '@divi/types';

import { type MultiViewDataGrouped } from '../../types';
import { updateData } from '../update-data';

/**
 * The function processes raw data by grouping it by module ID and applying any registered filters
 * before calling a callback function with the grouped data and a breakpoint.
 *
 * @since ??
 *
 * @param {Breakpoint.Name} breakpoint The current breakpoint, which can be 'phone', 'tablet', or 'desktop'.
 * @param {boolean} isInit Whether this is the first time the function is being called.
 */
export const processData = (breakpoint: Breakpoint.Name, isInit = false): void => {
  const dataRaw = window?.diviElementMultiViewData ?? [];

  if (!Array.isArray(dataRaw) || !dataRaw.length) {
    return;
  }

  const dataGrouped: MultiViewDataGrouped = {};

  dataRaw.forEach(item => {
    if (Object.prototype.hasOwnProperty.call(dataGrouped, item.moduleId)) {
      dataGrouped[item.moduleId] = {
        moduleName: item.moduleName,
        actions: dataGrouped[item.moduleId].actions.concat(item),
      };
    } else {
      dataGrouped[item.moduleId] = {
        moduleName: item.moduleName,
        actions: [item],
      };
    }
  });

  const baseBreakpoint: Breakpoint.Name = window?.diviBreakpointData?.baseBreakpointName ?? 'desktop';

  const breakpointNames = window?.diviBreakpointData?.enabledBreakpointNames ?? ['desktop', 'tablet', 'phone'];

  Object.keys(dataGrouped).forEach(moduleId => {
    const { actions } = dataGrouped[moduleId];

    updateData({
      items: actions,
      breakpoint,
      isInit,
      baseBreakpoint,
      breakpointNames,
    });
  });
};
